module.exports = __webpack_public_path__ + "img/twitter-image.17d29577.jpg";